function initAutocomplete() {
    var autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('addressInput')
    );

    autocomplete.addListener('place_changed', function() {
        var place = autocomplete.getPlace();
        if (!place.geometry) {
            // L'utilisateur a entré le nom d'un lieu qui n'a pas été résolu.
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        document.getElementById('addressSubmit').click();

        if (window.userMarker) {
            map.removeLayer(window.userMarker);
        }
      
        // Mettez à jour userLocation avec les nouvelles coordonnées
        userLocation = L.latLng(place.geometry.location.lat(), place.geometry.location.lng());
        // Ajoutez un nouveau marqueur avec la nouvelle position
        window.userMarker = L.marker(userLocation, {icon: window.userIcon}).addTo(map)
            .bindPopup(place.name.toUpperCase());
        // Centrez la carte sur la nouvelle position de l'utilisateur
        map.setView(userLocation, 13);
        // Mettez à jour la liste des magasins
        updateStoreList();
      
    });
}
  
document.addEventListener("DOMContentLoaded", function() {
    var userLocation; // Initialiser sans valeur
    var userMarker;
    var latitudeParDefaut = "46.6714624";
    var longitudeParDefaut = "5.5181312";
    var stores = [];
    var filteredStores = [];
    var markers = [];
    var radius = document.getElementById('radiusRange').value;
    var map = L.map('store-locator-map').setView([latitudeParDefaut, longitudeParDefaut], 10);
    var IconLink = [];
    IconLink['STARTER'] = 'https://cdn.shopify.com/s/files/1/0586/8450/6212/files/starter.png?v=1713270022';
    IconLink['RACER'] = 'https://cdn.shopify.com/s/files/1/0586/8450/6212/files/racer.png?v=1713270023';
    IconLink['HERO'] = 'https://cdn.shopify.com/s/files/1/0586/8450/6212/files/hero.png?v=1713270022';
    IconLink['USER'] = 'https://cdn.shopify.com/s/files/1/0586/8450/6212/files/user.png?v=1713272465';
    //IconLink['USER'] = 'https://cdn.shopify.com/s/files/1/0586/8450/6212/files/casque.png?v=1701803274';
  
    window.userIcon = L.icon({
        iconUrl: IconLink['USER'],
        iconSize: [50, 50], // Taille de l'icône
        iconAnchor: [25, 25], // Point d'ancrage de l'icône au point exact [x,y]
        popupAnchor: [0, -10] // Décaler le popup de 50 pixels vers le haut par rapport à l'icône
    });

    // Variable globale pour le marqueur utilisateur
    window.userMarker = null;
  
    // Mettre à jour la liste des magasins lorsque le rayon de recherche change
    document.getElementById('radiusRange').addEventListener('input', function(e) {
        radius = e.target.value;
        document.getElementById('radiusValue').innerText = `${radius} km`;
        updateStoreList();
    });

    /*function initializeMap() {
      const query = `
          query {
              stores(publicationState: LIVE, pagination: { start: 0, limit: -1 }) {
                  data {
                      id
                      attributes {
                          StoreName
                          Address
                          Address2
                          ZipCode
                          City
                          Country
                          PhoneNumber
                          Email
                          Website
                          Status
                          Geolocation
                      }
                  }
              }
          }
      `;

      fetch('https://admin-sed.om-consultant.fr/graphql', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer c6ade134722607fdf552696abc2a7856bc1c8a3d7c618f27a5ac4b362c8d25fedd7fdc3554155c6dffc7f530088e951e158b1be3f3707bcc6f4785144e55bcabada0d160f29be57f6b9923ab9685d211bc2f59983dfabfa938610d8a1b0bc0ac9df223dc0ee56c70625b5463e885bc4e023971f70dc2b3f5fc824d3006de1dd7'
          },
          body: JSON.stringify({ query: query })
      })
        .then(response => response.json())
        .then(data => {
            fetchedStores = data.data.stores.data;
            fetchedStores.forEach(function(item) {
              let storeItem = {};
              storeItem.name = item.attributes.StoreName;
              storeItem.address = item.attributes.Address;
              storeItem.address2 = item.attributes.Address2;
              storeItem.zipcode = item.attributes.ZipCode;
              storeItem.city = item.attributes.City;
              storeItem.country = item.attributes.Country;
              storeItem.phone = item.attributes.PhoneNumber;
              storeItem.email = item.attributes.Email;
              storeItem.website = item.attributes.Website;
              storeItem.status = item.attributes.Status;
              storeItem.addressComplete = item.attributes.Address + ' ' + item.attributes.ZipCode + ' ' + item.attributes.City + ' ' + item.attributes.Country;
              storeItem.lat = item.attributes.Geolocation.coordinates.lat;
              storeItem.lng = item.attributes.Geolocation.coordinates.lng;
              stores.push(storeItem);
            });
            updateStoreList();
        })
        .catch(error => console.error('Erreur lors du chargement des données des magasins:', error));
          
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '© OpenStreetMap contributors'
      }).addTo(map);
    }*/

    function initializeMap() {
        fetch('https://admin-sed.om-consultant.fr/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer c6ade134722607fdf552696abc2a7856bc1c8a3d7c618f27a5ac4b362c8d25fedd7fdc3554155c6dffc7f530088e951e158b1be3f3707bcc6f4785144e55bcabada0d160f29be57f6b9923ab9685d211bc2f59983dfabfa938610d8a1b0bc0ac9df223dc0ee56c70625b5463e885bc4e023971f70dc2b3f5fc824d3006de1dd7'
            },
            body: JSON.stringify({
                query: `
                    query {
                        stores(publicationState: LIVE, pagination: { start: 0, limit: -1 }) {
                            data {
                                id
                                attributes {
                                    StoreName
                                    Address
                                    Address2
                                    ZipCode
                                    City
                                    Country
                                    PhoneNumber
                                    Email
                                    Website
                                    Status
                                    Geolocation
                                }
                            }
                        }
                    }
                `
            })
        })
        .then(response => response.json())
        .then(data => {
            stores = data.data.stores.data.map(store => ({
                name: store.attributes.StoreName,
                address: store.attributes.Address,
                address2: store.attributes.Address2,
                zipcode: store.attributes.ZipCode,
                city: store.attributes.City,
                country: store.attributes.Country,
                phone: store.attributes.PhoneNumber,
                email: store.attributes.Email,
                website: store.attributes.Website,
                status: store.attributes.Status,
                addressComplete: `${store.attributes.Address} ${store.attributes.ZipCode} ${store.attributes.City}, ${store.attributes.Country}`,
                lat: store.attributes.Geolocation?.coordinates?.lat,
                lng: store.attributes.Geolocation?.coordinates?.lng
            }));
            updateStoreList();  // Mettre à jour la liste après avoir chargé les données
        })
        .catch(error => console.error('Erreur lors du chargement des données des magasins:', error));
    
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);
    }

  
    function updateStoreList() {
        // Supprimer tous les marqueurs existants de la carte
        markers.forEach(function(marker) {
            map.removeLayer(marker);
        });
        markers = []; // Réinitialiser le tableau de marqueurs
        
        // Créer un tableau pour stocker les coordonnées des magasins filtrés
        var bounds = [];
      
        // Filtrer et trier les magasins par distance
        filteredStores = stores
            .filter(store => store.status !== 'SANS_STATUT' && store.lat && store.lng && calculateDistance(userLocation.lat, userLocation.lng, store.lat, store.lng) <= radius)
            .sort((a, b) => calculateDistance(userLocation.lat, userLocation.lng, a.lat, a.lng) - calculateDistance(userLocation.lat, userLocation.lng, b.lat, b.lng));
        
        // Mettre à jour la liste HTML des magasins et les marqueurs
        var storeListElement = document.getElementById('storeList');
        storeListElement.innerHTML = ''; // Vider la liste actuelle

        filteredStores.forEach(function(store) {
            var storeItem = document.createElement('div');
            storeItem.classList.add('store-item');

            var iconStore = document.createElement('div');
            iconStore.classList.add('store-icon', 'icon-' + store.status.toLowerCase());
            iconStore.title = store.status.toUpperCase();
            iconStore.style.backgroundImage = "url('" + IconLink[store.status] + "')";
            storeItem.appendChild(iconStore);

            var storeHeader = document.createElement('div');
            storeHeader.classList.add('store-header');
          
            var storeName = document.createElement('div');
            storeName.classList.add('store-name');
            storeName.innerText = store.name;
            storeHeader.appendChild(storeName);         
          
            var storeAddress = document.createElement('div');
            storeAddress.classList.add('store-address');
            storeAddress.innerText = store.address + '\n ' + store.zipcode + ' ' + store.city;
            storeHeader.appendChild(storeAddress);

            storeItem.appendChild(storeHeader);
            storeListElement.appendChild(storeItem);

            // Créer un marqueur pour chaque magasin
            var storeIcon = getStoreIcon(store); // Fonction pour récupérer l'icône du magasin
            var HTMLMarker = `<h3>${store.name}</h3>
                              ${store.address}<br>
                              ${store.zipcode} ${store.city}<br>`;
            HTMLMarker += (store.phone) ? `<span style="font-size:20px;"><i class="fa fa-phone"></i> <b>${store.phone}</b></span><br>` : ``;
            HTMLMarker += (store.email) ? `<span style="font-size:12px;"><i class="fa fa-envelope"></i> <b>${store.email}</b></span><br>` : ``;
            HTMLMarker += (store.website) ? `<span style="font-size:12px;"><i class="fa fa-globe"></i> <b>${store.website}</b></span><br>` : ``;          
            HTMLMarker +=    `<br><a href="https://maps.google.com/?saddr=My+Location&daddr=` + encodeURIComponent(store.addressComplete) + `" target="_blank">
                                  <button type="button" class="button button--primary">` + translations.get_directions + `</button>
                              </a>`;
          
            var marker = L.marker([store.lat, store.lng], {icon: storeIcon}).bindPopup(HTMLMarker);
            markers.push(marker);
            marker.addTo(map);

            // Ajouter les coordonnées du magasin au tableau des limites
            bounds.push(marker.getLatLng());

            // Ajouter un écouteur de clic pour centrer la carte sur le magasin
            storeItem.addEventListener('click', function() {
                map.setView([store.lat, store.lng], 13);
                marker.openPopup();
            });
        });

        // Si nous avons des magasins filtrés, ajuster la vue de la carte pour les inclure tous
        if (bounds.length > 0) {
            map.fitBounds(bounds, {
                padding: [50, 50], // ajoute un peu de marge autour des bords
                maxZoom: 13 // définit un zoom maximum pour que la carte ne soit pas trop zoomée
            });
        }
      
    }

    // Fonction pour récupérer l'icône basée sur le statut du magasin
    function getStoreIcon(store) {
        var linkIcon;
      
        if(store.status) {
            linkIcon = IconLink[store.status];
        } else IconLink['STARTER'];
      
        return L.icon({
            iconUrl: linkIcon,
            iconSize: [50, 50],
            iconAnchor: [25, 50],
            popupAnchor: [0, -50]
        });
    }
                          
    function calculateDistance(lat1, lon1, lat2, lon2) {
        var R = 6371; // Rayon de la terre en km
        var dLat = deg2rad(lat2 - lat1);
        var dLon = deg2rad(lon2 - lon1);
        var a = 
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var distance = R * c; // Distance en km
        return distance;
    }

    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    document.getElementById('addressSubmit').addEventListener('click', function() {
        var address = document.getElementById('addressInput').value;
        // Utilisez un service de géocodage pour obtenir la latitude et la longitude de l'adresse
        geocodeAddress(address, function(lat, lng) {
            if (window.userMarker) {
                map.removeLayer(window.userMarker);
            }
            // Mettez à jour userLocation
            userLocation = L.latLng(lat, lng);
            // Centrez la carte sur la nouvelle location
            map.setView(userLocation, 13);
            // Mettez à jour la liste des magasins avec la nouvelle location
            updateStoreList();
            // Et éventuellement, ajoutez un marqueur pour la nouvelle location
            window.userMarker = L.marker(userLocation, {icon: window.userIcon}).addTo(map)
              .bindPopup(address.toUpperCase());        
        });
    });
    
    function geocodeAddress(address, callback) {
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(address) + '&key=AIzaSyCYzYXjHjbikSMCep4LX3wYs0XbK1208ZQ')
            .then(response => response.json())
            .then(data => {
                if (data && data.results && data.results.length > 0) {
                    var lat = data.results[0].geometry.location.lat;
                    var lng = data.results[0].geometry.location.lng;
                    callback(lat, lng);
                } else {
                    alert(translations.not_found);
                }
            });
    }
  
    // Vérifier si la géolocalisation est prise en charge
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var userLat = position.coords.latitude;
            var userLng = position.coords.longitude;
            userLocation = L.latLng(userLat, userLng);

            window.userMarker = L.marker(userLocation, {icon: window.userIcon})
              .bindPopup(translations.here).openPopup();
            window.userMarker.addTo(map);
        }, function() {
            console.error("L'accès à la position est refusé par l'utilisateur");
            map.setView([latitudeParDefaut, longitudeParDefaut], 13);
        });
    } else {
        console.error("La géolocalisation n'est pas prise en charge par ce navigateur");
        map.setView([latitudeParDefaut, longitudeParDefaut], 13);
    }

    initializeMap();
});